import useLogin from "@/stores/login";
import { getCasConfig, getCasLogoutUrl } from "@/request/api/login";

/**
 * 清理本地登录态；机构启用 CAS 时跳转后端 /cas/logout，由校方清除 TGT
 * @returns {Promise<boolean>} true 表示已跳转 CAS 登出，调用方勿再自行跳转
 */
export async function exitWithOptionalCas() {
  const loginStore = useLogin();
  const agencyId = loginStore.agencyId;
  const token = loginStore.token;
  let logoutWithCas = false;

  if (agencyId != null && agencyId !== "") {
    try {
      const res = await getCasConfig({ agencyId });
      if (res.status == 10000 && res.data && res.data.enabled) {
        logoutWithCas = res.data.logoutWithCas !== false;
      }
    } catch (e) {
      logoutWithCas = false;
    }
  }

  loginStore.isLogin = false;
  loginStore.token = "";
  loginStore.code = "";
  loginStore.agencyId = undefined;
  loginStore.userId = undefined;
  loginStore.roleId = -1;
  loginStore.username = undefined;
  loginStore.headImg =
    "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png";

  if (logoutWithCas) {
    window.location.href = getCasLogoutUrl(agencyId, token);
    return true;
  }
  return false;
}
